<template>
  <md-table md-card>
    <md-table-toolbar>
      <slot name="header">
        <h2 class="md-title" v-if="cardTitle">
          {{ cardTitle }}
        </h2>
      </slot>
    </md-table-toolbar>

    <md-table-row
      v-for="(permissions, resource) in resourcePermissions"
      :key="resource"
    >
      <md-table-cell>
        <span class="md-body-2"> {{ getModelLabel(resource) }} </span>
      </md-table-cell>
      <slot name="cell" :permissions="permissions">
        <md-table-cell>
          <template>
            <slot
              name="verb"
              v-bind="{ verb }"
              :data="data"
              v-for="{ permission, label, verb, ...data } in permissions"
            >
              <md-chip
                :key="verb"
                :class="
                  PERMISSIONS_FORMAT[verb]
                    ? PERMISSIONS_FORMAT[verb].class
                    : 'md-primary'
                "
              >
                <md-icon>
                  {{
                    PERMISSIONS_FORMAT[verb]
                      ? PERMISSIONS_FORMAT[verb].icon
                      : "check_circle"
                  }}
                </md-icon>
                <strong> {{ label || verb }} </strong>
                <md-tooltip>
                  {{ permission }}
                </md-tooltip>
              </md-chip>
            </slot>
          </template>
        </md-table-cell>
      </slot>
    </md-table-row>
  </md-table>
</template>

<script>

import { mapGetters } from 'vuex'

const PERMISSIONS_FORMAT = {
  Delete: {
    icon: 'cancel',
    class: 'md-danger'
  },
  Get: {
    icon: 'remove_red_eye',
    class: 'md-info'
  },
  Create: {
    icon: 'save',
    class: 'md-success'
  },
  Post: {
    icon: 'save',
    class: 'md-success'
  },
  PostPut: {
    icon: 'save',
    class: 'md-success'
  },
  CreateEdit: {
    icon: 'save',
    class: 'md-success'
  },
  View: {
    icon: 'remove_red_eye',
    class: 'md-info'
  },
  Register: {
    icon: 'save',
    class: 'md-success'
  },
  ListEdit: {
    icon: 'edit',
    class: 'md-info'
  },
  List: {
    icon: 'remove_red_eye',
    class: 'md-info'
  },
  Edit: {
    icon: 'save',
    class: 'md-success'
  },
  Close: {
    icon: 'save',
    class: 'md-success'
  },
  Cancel: {
    icon: 'cancel',
    class: 'md-danger'
  },
  Reject: {
    icon: 'cancel',
    class: 'md-danger'
  },
}

/**
 * User Permissions Card - Displays permission groups
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 * @version 0.5
 **/
export default {

  name: 'UserPermissionsCard',

  props: {
    resourcePermissions: {
      type: Object
    },
    cardTitle: {
      type: String,
      default: 'Permisos'
    }
  },

  computed: {
    ...mapGetters({
      getModelLabel: 'account/getModelLabel'
    })
  },

  filters: {
    permissionIcon(permission) {
      return PERMISSIONS_FORMAT[permission]
    },
    removePermissionPostfix(permission) {
      return permission.replace(/Permission/, '')
    }
  },

  data () {
    return {
      PERMISSIONS_FORMAT
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfileComponents/UserPermissionsCard.vue